module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"breakdown_view":"Breakdown View","copy":"Copy","copy_success":"Copy successful","copy_fail":"Copy failed","copy_error":"Error during copy"},"zh":{"breakdown_view":"拆书查看","copy":"复制","copy_success":"复制成功","copy_fail":"复制失败","copy_error":"复制时出错"}}')
  delete Component.options._Ctor
}
